import { GridColumnVisibilityModel, GridFilterModel, GridSortModel } from '@mui/x-data-grid-premium'

export const defaultColumnOrder: string[] = [
  '__search',
  'org_uuid',
  'name',
  'discovery',
  'website',
  'googleAdsId',
  'total',
  'monthlyTotal',
  'spend',
  'grossProfit',
  'totalGrossProfit',
  'implementationFee',
  'website',
  'trackingType',
  'status',
  // 'old_status',
  'contractedBy',
  'affiliated',
  'type',
  'primaryContact',
  'orgNameReference',
  'contacts',
  'owner',
  'vertical',
  'social',
  'team_details',
  'AM',
  'BDE',
  'DMS',
  'MIA',
  'PM',
  'QA',
  'SEO',
  'other',
  'creation_timestamp',
]
export const defaultSortModel: GridSortModel = [{ field: 'name', sort: 'asc' }]

export const defaultVisibilityModel: GridColumnVisibilityModel = {
  org_uuid: false,
  affiliated: false,
  source: false,
  street: false,
  city: false,
  state: false,
  zip: false,
  cmsUsed: false,
  social: false,
  dealIds: false,
  trackingType: false,
  old_status: false,
  creation_timestamp: false,
  implementationFee: false,
  __tree_data_group__: false,
  orgNameReference: false,
  // Hide tree-specific columns in server-side mode
  discovery: false,
  QA: false,
  other: false,
}

export const defaultFilterModel: GridFilterModel = {
  items: [],
  quickFilterValues: [],
  quickFilterExcludeHiddenColumns: false,
}
export const pinnedColumns = { left: ['__check__', 'name'], right: [] }
export const EDITABLE_FIELDS = [
  // Basic info
  'website',
  'googleAdsId',
  'status',
  'type',
  'vertical',
  // Tracking
  'trackingType',
  'trackingUrl',
  // Relationships (org_uuid arrays)
  'contractedBy',
  'affiliated',
  // Contacts (contacts_uuid arrays)
  'primaryContact',
  'contacts',
  'billingContact',
  // Owner
  'owner',
  // Team roles - column field names (for isCellEditable)
  'AM',
  'BDE',
  'DMS',
  'MIA',
  'PM',
  'QA',
  'SEO',
  'other',
  // Team roles - data field names (valueSetter stores at 'team.X', for getChangedFields)
  'team.AM',
  'team.BDE',
  'team.DMS',
  'team.MIA',
  'team.PM',
  'team.QA',
  'team.SEO',
  'team.other',
]
